import React from "react";
import { Grid } from "@mui/material";
import LabeledText from "../../../Widgets/LabeledText";
import { ObservedBehaviorsFormValues } from "./interface";

interface ViewFieldsProps {
  formValues: ObservedBehaviorsFormValues;
}

export const ViewFields: React.FC<ViewFieldsProps> = ({ formValues }) => {
  return (
    <Grid container sx={{ rowGap: "24px" }}>
      <LabeledText label="Direct Observations" value={formValues.directObservations} />
      <LabeledText label="Strengths" value={formValues.strengths} />
      <LabeledText label="Preferences" value={formValues.preferences} />
    </Grid>
  );
};

export default ViewFields;
